import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { Container, Button } from 'react-bootstrap';

import Hero from './hero';

//import './home.scss';


class Home extends React.Component {

  constructor(props) {
    super(props);
    this.handleFinishNeedCalculation = this.handleFinishNeedCalculation.bind(this);
    this.state = {needCalculationPerformed: false};
  }
  handleFinishNeedCalculation(values) {
    this.setState({ needCalculationPerformed: true, need_values: values} );
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <Hero />
      

      <Container>

      <Trans i18nKey='home.body' components={{h2: <h2/>, p:<p/>, h3: <h3/>, b:<b/>, a:<a/>}}/>



<Button href="https://app.nutrfy.com/signup" target="_blank" rel="noopener noreferrer" variant="primary" size="lg">
    {t('components.button_join')}</Button>




      </Container>
      </>
    )
  }
}

export default withTranslation()(Home);